import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { UserInfo } from '../../../shared/interface/user-info.interface';
import { CacheService } from '../../../shared/services/cache.service';
import { Permission } from '../../../common/enums/permission.enum';
import { CommonService } from '../../../shared/services/common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Utils } from '../../../shared/Utils/utils';
import { SortOrder } from '../../constants/reports.constants';
import { AnonymousRetailSalesConstants } from '../../constants/anonymous-retail-orders.constants';
import { AnonymousRetailOrderDetail, RetailBonusMessages, RetailBonusRecords, RetailBonusReqObj, RetailBonusReqValues, RetailBonusResponse, RetailParticipatingStores, RetailSalesModel } from '../../interface/anonymous-retail-orders.interface';
import { AnonymousRetailOrderService } from '../../services/anonymous-retail-order.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationType } from '../../enums/notification-types.enum';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { RetailBonusStatus } from '../../enums/retail-bonus-status.enum';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';
import { Subject } from 'rxjs';
import { exhaustMap } from 'rxjs/operators/exhaustMap';
import { concatMap, map, takeUntil } from 'rxjs/operators';
import { RowStatus } from '../../../shared/common/enumerations';
import { DecimalPipe } from '@angular/common';
import { Modal } from 'ngx-modal';
import { PaginationInstance } from 'ngx-pagination';
import * as moment from 'moment';
import { AppLoaderService } from '../../../shared/services/app-loader.service';


@Component({
  selector: 'app-anonymous-retail-order',
  templateUrl: '../../templates/template1/views/orders/anonymous-retail-order.component.html',
  styleUrls: ['../../templates/template1/themes/default/less/anonymous-retail-order.component.less',
    '../../templates/template1/themes/default/css/ticket.less', '../../templates/template1/themes/default/css/my-team-tickets.component.less'],
  providers: [DecimalPipe]
})
export class AnonymousRetailOrderComponent implements OnInit, OnDestroy {
  @ViewChild('addNewAnonymousRetailOrders') AnonymousRetailOrdersPopup: Modal;
  @ViewChild('confirmationModal') confirmationModalPopup: Modal;
  @ViewChild('viewOrdersModal') viewOrdersPopup: Modal;
  @ViewChild('viewStatusModal') viewStatusPopup: Modal;
  hasAnonymousRetailOrderPermission: any[] = [
    Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_CREATE,
    Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_EDIT,
    Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_DELETE,
    Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_APPROVE
  ];
  isAnonymousRetailCreatePermission: boolean;
  userInfo: UserInfo;
  message: RetailBonusMessages = { msg: "", class: "", icon: "", value: false };
  isLoading: { retailStores: string, participatingStores: string } = { retailStores: "", participatingStores: "" };
  date = new Date();
  yearValues: number[] = [];
  FilteringListForm: FormGroup;
  CreateOrEditForm: FormGroup;
  sortColumn: string;
  isDesc: boolean = true;
  sortOrderEnum = SortOrder;
  tableColumnName = AnonymousRetailSalesConstants;
  RetailBonusStatus = RetailBonusStatus;
  retailStoresParticipation: RetailParticipatingStores[] = [];
  pageNumber = AnonymousRetailSalesConstants.PageNumber;
  pageSize = AnonymousRetailSalesConstants.PageSize;
  pageCount = 0;
  RetailBonusSalesData: RetailBonusRecords[] = [];
  hideButton: boolean = true;
  isUpdate: boolean = false;
  recordId;
  retailStores: RetailParticipatingStores[] = [];
  overlay: boolean = false;
  updateStoreName: string | number = '';
  storeId: number;
  anonymousRetailOrderDetails : AnonymousRetailOrderDetail[]= [];
  anonymousRetailOrderDetail: AnonymousRetailOrderDetail;
  orderDetailPageNumber = AnonymousRetailSalesConstants.PageNumber;
  orderDetailPageSize = AnonymousRetailSalesConstants.PageSize;
  orderDetailPageCount = 0;
  anonymousRetailSalesId: number;
  isErrorOccured = false;
  noRecordExist = false;
  monthAndYear = [
    { monthName: "January", value: 1 }, { monthName: "February", value: 2 }, { monthName: "March", value: 3 },
    { monthName: "April", value: 4 }, { monthName: "May", value: 5 }, { monthName: "June", value: 6 },
    { monthName: "July", value: 7 }, { monthName: "August", value: 8 }, { monthName: "September", value: 9 },
    { monthName: "October", value: 10 }, { monthName: "November", value: 11 }, { monthName: "December", value: 12 }
  ];

  anonymousRetailOrderGenerationStatusList = [
    {id:204, status:'Pending'},
    {id:205, status:'Completed'},
    {id:206, status:'Failed'}
]

  public paginationInstance: PaginationInstance = {
    id: 'shared-retail-sales-pagination',
    itemsPerPage: AnonymousRetailSalesConstants.PageSize,
    currentPage: AnonymousRetailSalesConstants.PageNumber
  };

  public orderDetailPaginationInstance: PaginationInstance = {
    id: 'order-detail-pagination',
    itemsPerPage: AnonymousRetailSalesConstants.PageSize,
    currentPage: AnonymousRetailSalesConstants.PageNumber
  };

  deleteSub$ = new Subject<any>();
  ngUnsubscribe = new Subject<void>();
  digitsAndDecimals:number[] = [7, 3];
  isEnableViewOrderAndRegenerateOrder :boolean = false; // remove flag once task are planned view and regenerate orders
  retailInfoObj:any;


  constructor(private _cacheService: CacheService, private _commonService: CommonService, private _formbuilder: FormBuilder, private _decimalPipe: DecimalPipe,
    private _anonymousRetailOrderService: AnonymousRetailOrderService, private _translatePipe: TranslateService, private _loader: AppLoaderService) { }

  ngOnInit() {
    this.initializeFilterForm();
    this.initializeCreateOrEditForm();
    this.populateYearValues();
    this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    this.isAnonymousRetailCreatePermission = this.getPermissionLevel([this.hasAnonymousRetailOrderPermission[0]]);
    this.getRetailStores();
    this.initializeSub();

  }


  initializeFilterForm() {
    this.FilteringListForm = this._formbuilder.group({
      store: [" ", [Validators.required, Utils.noEmptyString]],
      year: [" "],
      month: [" "]
    })
  }

  initializeCreateOrEditForm() {
    this.CreateOrEditForm = this._formbuilder.group({
      store: [" ", [Validators.required, Utils.noEmptyString]],
      year: [{ value: '', disabled: true }, Validators.required],
      month: [{ value: '', disabled: true }, Validators.required],
      salesCC: [0, [Validators.required,Validators.pattern(/^\d{1,7}(\.\d{0,3})?$/)]]
    })
  }

  /**
 * populate year dropdown values based on specific year
 */
  populateYearValues() {
    const year = +AnonymousRetailSalesConstants.YearValue;
    const curYear = +this.date.getFullYear()
    const YearDiff = curYear - year;
    for (let i = 0; i <= YearDiff; i++) {
      this.yearValues.push(year + i)
    }
    this.yearValues.sort();
    this.FilteringListForm.get('year').setValue(this.date.getFullYear());
    this.FilteringListForm.get('month').setValue(this.date.getMonth() + 1)
  }

  getPermissionLevel(hasAnonymousRetailOrderPermission: number[]): boolean {
    return this._anonymousRetailOrderService.getAnonymousRetailAccess(hasAnonymousRetailOrderPermission)
  }

  /**
   * get retail participating store in search screen
   */
  getRetailStores() {
    this.isLoading.participatingStores = AnonymousRetailSalesConstants.participatingStores;
    this._anonymousRetailOrderService.getRetailParticipatingStores().pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res && res.success) {
        if (res.data && !!res.data.length) {
          this.retailStoresParticipation = this.userInfo && this.userInfo.hasSystemRole ? [...res.data] : this.populateRetailStores(res.data);
        }else{
          this.retailStoresParticipation=[]
        }
      }
      else {
        this.retailStoresParticipation = [];
        this.displayErrorMsg(res,(this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Error_Occured_While_Retriving_Stores) as any).value);
      }
      this.isLoading.participatingStores = ""
      this.overlay = false;
    },
      err => {
        this.retailStoresParticipation = [];
        this.displayErrorMsg('',(this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Error_Occured_While_Retriving_Stores) as any).value);
        this.isLoading.participatingStores = ""
      })
  }


  /**
   * 
   * @param retailStoresData populate store based on user permission
   */
  populateRetailStores(retailStoresData) {
    const userAllowedStores = this.userInfo && this.userInfo.privileges && this.userInfo.privileges.stores ? this.userInfo.privileges.stores : [];
    const compareUserWithRetailStores = userAllowedStores ? userAllowedStores.filter(permission => retailStoresData.find(stores => stores.id == permission.id)) : [];
    const checkRetailAccessStores = compareUserWithRetailStores ? compareUserWithRetailStores.filter(userStores => userStores.permissions.some(stores => this.hasAnonymousRetailOrderPermission.includes(stores))) : [];
    const retailParticipationStores = checkRetailAccessStores ? checkRetailAccessStores.map(stores => retailStoresData.find(participatingStores => participatingStores.id == stores.id)) : [];
    return [...retailParticipationStores];
  }

  /**
 * get retail bonus sales record
 */
  getRetailBonusSalesRecords() {
    if (this.FilteringListForm.valid) {
      this.overlay = true;
      const retailBonusObj: RetailBonusReqValues = {
        storeID: +this.FilteringListForm.get('store').value,
        year: +this.FilteringListForm.get('year').value,
        month: +this.FilteringListForm.get('month').value,
        pageNumber: +this.pageNumber,
        pageSize: +this.pageSize,
        sort: this.isDesc ? AnonymousRetailSalesConstants.DESC : AnonymousRetailSalesConstants.ASC,
        sortColumn: this.sortColumn
      }
      if(this.FilteringListForm && this.FilteringListForm.get('store').value){
        this.storeId = this.FilteringListForm.get('store').value;
      }
      this._anonymousRetailOrderService.getRetailBonusSales(retailBonusObj).pipe(
        concatMap((salesRecords) => {
          let userIds = salesRecords.data.map(userid => userid.approvedBy).filter((value, index, self) => (value && self.indexOf(value) === index));
          return userIds && userIds.length > 0 ? this._anonymousRetailOrderService.getUsersDetails(userIds).pipe(catchError(err => of([salesRecords, []])),
            map(userIDS => [salesRecords, userIDS])) : of([salesRecords, []]);
        }
        ),
        map(([salesRecords, userIDS]) => ({
          ...salesRecords, data: (salesRecords && salesRecords.data && !!salesRecords.data.length) ? salesRecords.data.map(sales => {
            const approvedBy = userIDS.find(user => user.id === sales.approvedBy);
            sales.approvedBy = approvedBy ? approvedBy.userName : "";
            return sales
          }) : []
        })
        ),
        takeUntil(this.ngUnsubscribe)
      ).subscribe(res => {
        let salesRecords = res;
        this.populateSalesRecords(salesRecords);
        this.overlay = false;
      }, err => {
        this.resetRetailSalesValues();
        this.displayErrorMsg('', (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Error_Occured_While_Retail_Sales_Info) as any).value);
      })
    }
  }

  /**
   * Based on salesRecords bind the values to grid
   * @param salesRecords 
   */
  populateSalesRecords(salesRecords) {
    if (salesRecords && salesRecords.isSuccess && salesRecords.data && !!salesRecords.data.length) {
      for (let i = 0; i < salesRecords.data.length; i++) {
        const store = this.retailStoresParticipation.filter(country => +country.id == +salesRecords.data[i].storeID)[0];
        salesRecords.data[i].storeName = store ? store.name : salesRecords.data[i].storeID;
        salesRecords.data[i].isEdit = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_EDIT + ']'), AccessLevel.Store, +salesRecords.data[i].storeID);
        salesRecords.data[i].isDelete = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_DELETE + ']'), AccessLevel.Store, +salesRecords.data[i].storeID);
        salesRecords.data[i].isCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_CREATE + ']'), AccessLevel.Store, +salesRecords.data[i].storeID);
        salesRecords.data[i].isApprove = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_APPROVE + ']'), AccessLevel.Store, +salesRecords.data[i].storeID);
        salesRecords.data[i].orderCC = salesRecords.data[i].orderCC ? this._decimalPipe.transform(salesRecords.data[i].orderCC, '1.3-3').replace(/,/g, '') : salesRecords.data[i].orderCC;
        salesRecords.data[i].orderTotal = salesRecords.data[i].orderTotal ? this._decimalPipe.transform(salesRecords.data[i].orderTotal, '1.2-2').replace(/,/g, '') : salesRecords.data[i].orderTotal;
        salesRecords.data[i].currencyCode = store ? store.currencyCode : '';
        salesRecords.data[i].totalSalesCC = salesRecords.data[i].totalSalesCC ? this._decimalPipe.transform(salesRecords.data[i].totalSalesCC, '1.3-3').replace(/,/g, '') : salesRecords.data[i].totalSalesCC;
        salesRecords.data[i].isShowRegenerateOrder = salesRecords.data[i].isShowRegenerateOrder;
      }
      this.RetailBonusSalesData = [...salesRecords.data];
      this.pageCount = salesRecords.pageDetails && (salesRecords.pageDetails.recordsAll).toString() ? +salesRecords.pageDetails.recordsAll : 0;
    }
    else if (salesRecords && !salesRecords.isSuccess && salesRecords.validations && !!salesRecords.validations.length) {
      
      if(salesRecords.validations[0].name && salesRecords.validations[0].name.toLowerCase() == AnonymousRetailSalesConstants.FAILED){
        const errorMsg = (this._translatePipe.get('retail-orders.Exception occurred while fetching shared retail sales info for store {{storeID}}, year {{year}}, month {{month}}', {
          storeID: this.FilteringListForm.get('store').value? this.FilteringListForm.get('store').value:'',
          year: this.date.getFullYear(),
          month: this.date.getMonth() + 1
        }) as any).value;
        this._commonService.createNotification("", errorMsg, NotificationType.ERROR);
      } 
      else if(salesRecords.validations[0].name && salesRecords.validations[0].name.toLowerCase() == AnonymousRetailSalesConstants.Completed){
        const errorMsg = (this._translatePipe.get('retail-orders.No records for shared retail sales info for store {{storeID}}, year {{year}}, month {{month}}', {
          storeID: this.FilteringListForm.get('store').value? this.FilteringListForm.get('store').value:'',
          year: this.date.getFullYear(),
          month: this.date.getMonth() + 1
        }) as any).value;
        this._commonService.createNotification("", errorMsg, NotificationType.ERROR);
      }
      else{
        const msg = salesRecords.validations[0].message ? salesRecords.validations[0].message : AnonymousRetailSalesConstants.Error_Occured_While_Retail_Sales_Info;
        this._commonService.createNotification("", (this._translatePipe.get('retail-orders.' + msg) as any).value, NotificationType.ERROR);
      }     
      this.resetRetailSalesValues();
    }
    else {
      this.resetRetailSalesValues();
    }
  }

  resetRetailSalesValues() {
    this.RetailBonusSalesData = [];
    this.pageCount = 0;
    this.pageSize = AnonymousRetailSalesConstants.PageSize;
    this.pageNumber = AnonymousRetailSalesConstants.PageNumber;
  }

  openRetailModal(value: string, data?: RetailBonusRecords) {
    this.hideButton = true;
    this.recordId = " ";
    this.enableformControls();
    this.resetErrorMessage();
    this.resetCreateOrEdit();
    if (value.toLowerCase() == AnonymousRetailSalesConstants.CREATE.toLowerCase()) {
      this.retailStores = [];
      this.CreateOrEditForm.get('year').setValue(this.date.getFullYear());
      this.CreateOrEditForm.get('month').setValue(this.date.getMonth() + 1);
      this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(0, '1.3-3'));
      this.recordId = "";
      this.isUpdate = false;
      this.getStoreData();
    }
    else {
      this.isUpdate = true;
      this.CreateOrEditForm.get('store').setValue(data.storeID.toString())
      this.CreateOrEditForm.get('year').setValue(data.salesYear);
      this.CreateOrEditForm.get('month').setValue(data.salesMonth);
      (data && data.totalSalesCC.toString()) ?
        this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(data.totalSalesCC, '1.3-3').replace(/,/g, '')) :
        this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(0, '1.3-3'));
      this.recordId = +data.id;
      this.updateStoreName = data.storeName;
    }
    this.AnonymousRetailOrdersPopup.open();
  }



  closeRetailModal() {
    this.resetErrorMessage();
    this.resetCreateOrEdit();
    this.AnonymousRetailOrdersPopup.close();
  }

  /**
   * create a new/update record anonymous retail sales record
   */
  onSubmit() {
    if (this.CreateOrEditForm.valid) {
      this.hideButton = false;
      this.resetErrorMessage();
      let createRetailSalesObj: RetailBonusReqObj = {
        storeId: +this.CreateOrEditForm.get('store').value,
        salesYear: +this.CreateOrEditForm.get('year').value,
        salesMonth: +this.CreateOrEditForm.get('month').value,
        totalSalesCC: +this.CreateOrEditForm.get('salesCC').value
      }
      if (this.isUpdate) {
        createRetailSalesObj.updatedBy = +this.userInfo.userId;
        createRetailSalesObj.id = +this.recordId;
        this.updateAnonyumousRetailSales(createRetailSalesObj, false)
      }
      else {
        createRetailSalesObj.createdBy = +this.userInfo.userId;
        this.addNewAnonyumousRetailSales(createRetailSalesObj)
      }
    }

  }

  addNewAnonyumousRetailSales(createRetailSalesObj: RetailBonusReqObj) {
    if (this.CreateOrEditForm.valid) {
      this._anonymousRetailOrderService.createRetailBonusSales(createRetailSalesObj).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        if (res && res.isSuccess && res.validations && res.validations.length == 0) {
          const message: any = (this._translatePipe.get('retail-orders.Sales entry created Successfully') as any).value;
          const modalStore = this.CreateOrEditForm.get('store').value?this.CreateOrEditForm.get('store').value.toString():'';
          const searchStore = (modalStore && this.retailStoresParticipation && !!this.retailStoresParticipation.length)?this.retailStoresParticipation.find(storeID=>((storeID.id).toString())==modalStore):'' ;
          if(searchStore && searchStore.id){
            this.FilteringListForm.get('store').setValue((searchStore.id).toString());
            this.FilteringListForm.get('year').setValue(this.date.getFullYear());
            this.FilteringListForm.get('month').setValue(this.date.getMonth() + 1)
          }
          this.handleSuccessResponse(message);
        }
        else {
          this.displayModalErrorMsg(res, (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.ARS_Create_Error) as any).value,createRetailSalesObj.storeId,AnonymousRetailSalesConstants.CREATE)
        }
      }, err => {
        this.displayModalErrorMsg('', (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.ARS_Create_Error) as any).value)
      })
    }

  }

  updateAnonyumousRetailSales(createRetailSalesObj: RetailBonusReqObj, isDelete: boolean) {
    this._anonymousRetailOrderService.updateOrDeleteRetailBonusSales(createRetailSalesObj, isDelete).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res && res.isSuccess) {
        const message: any = (this._translatePipe.get('retail-orders.Sales entry updated Successfully') as any).value;
        this.handleSuccessResponse(message);
      }
      else {
        this.displayModalErrorMsg(res, (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.ARS_Update_Error) as any).value,createRetailSalesObj.id,AnonymousRetailSalesConstants.UPDATE)
      }
    }, err => {
      this.displayModalErrorMsg('', (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.ARS_Update_Error) as any).value)
    })
  }


  /**
   * Confirmation popup modal
   * @param data 
   */
  confirmation(data: RetailBonusRecords) {
    this.hideButton = true;
    this.recordId = data.id;
    this.setValuesToForm(data);
    this.resetErrorMessage();
    this.confirmationModalPopup.open();
  }

  deleteRetailSalesRecord() {
    this.hideButton = false;
    this.resetErrorMessage();
    let createRetailSalesObj = {
      storeId: this.CreateOrEditForm.get('store').value ? +this.CreateOrEditForm.get('store').value : '',
      salesYear: +this.CreateOrEditForm.get('year').value,
      salesMonth: +this.CreateOrEditForm.get('month').value,
      totalSalesCC: +((this.CreateOrEditForm.get('salesCC').value).replace(/,/g, '')),
      updatedBy: +this.userInfo.userId,
      id: this.recordId
    }
    this.deleteSub$.next(createRetailSalesObj);
  }


  initializeSub() {
    this.deleteSub$.pipe(
      exhaustMap((reqObj) =>
        this._anonymousRetailOrderService.updateOrDeleteRetailBonusSales(reqObj, true)
          .pipe(catchError(err => { return of({ isError: true, err: err }) }))
      )
    ).subscribe(res => {
      if (res.isError) {
        const message: any = (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.ARS_Delete_Error) as any).value;
        this.handleErrorResponse(message);
        return;
      }
      if (res && res.isSuccess) {
        this.hideButton = true;
        const message: any = (this._translatePipe.get('retail-orders.Sales entry deleted Successfully') as any);
        this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
        this.getRetailBonusSalesRecords();
        this.closeConfirmationPopup();
      }
      else {
        this.displayModalErrorMsg(res, (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.ARS_Delete_Error) as any).value,this.recordId,AnonymousRetailSalesConstants.DELETE);
      }
    },
      err => {
        this.displayModalErrorMsg('', (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.ARS_Delete_Error) as any).value);
      })
  }

  closeConfirmationPopup() {
    this.resetErrorMessage();
    this.recordId = "";
    this.confirmationModalPopup.close();
  }

  handleSuccessResponse(message) {
    this.hideButton = false;
    this._commonService.createNotification("", message, NotificationType.SUCCESS);
    this.CreateOrEditForm.get('store').disable();
    this.CreateOrEditForm.get('salesCC').disable();
    this.closeRetailModal();
    this.getRetailBonusSalesRecords();
  }

  handleErrorResponse(message) {
    this.hideButton = true;
    this.populateErrormMessages(message, NotificationType.ERROR, true, AnonymousRetailSalesConstants.CloseIcon);

  }


  /**
   * reset the CreateOrEdit form
   */
  resetCreateOrEdit() {
    this.CreateOrEditForm.get('store').setValue('');
    this.CreateOrEditForm.get('year').setValue(" ");
    this.CreateOrEditForm.get('month').setValue(" ");
    this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(0, '1.3-3'));
    this.CreateOrEditForm.get('store').markAsUntouched();
  }

  resetFilterForm() {
    this.overlay = true;
    this.FilteringListForm.get('store').setValue(" ");
    this.FilteringListForm.get('year').setValue(this.date.getFullYear());
    this.FilteringListForm.get('month').setValue(this.date.getMonth() + 1)
    this.isDesc = true;
    this.sortColumn = null;
    this.pageNumber = AnonymousRetailSalesConstants.PageNumber;
    this.pageSize = AnonymousRetailSalesConstants.PageSize;
    this.RetailBonusSalesData = [];
    this.pageCount = 0;
    this.FilteringListForm.get('store').markAsUntouched();
    this.getRetailStores();
  }

  /**
     * Sort by column name
     * @param sortColumn 
     */
  sortByColumn(sortColumn: string) {
    if (this.FilteringListForm.valid) {
      this.isDesc = (this.sortColumn == sortColumn || sortColumn == "") ? !this.isDesc : this.isDesc;
      this.sortColumn = sortColumn;
      this.getRetailBonusSalesRecords();
    } else {
      const message = (this._translatePipe.get('retail-orders.Please select store to perform any action') as any).value;
      this._commonService.createNotification("", message, NotificationType.ERROR);
    }

  }

  populateErrormMessages(message: string, type: string, val: boolean, icon: string) {
    this.message.msg = message;
    this.message.class = type;
    this.message.value = val;
    this.message.icon = icon;
  }

  /**
   * reset the error messages
   */
  resetErrorMessage() {
    this.message.msg = " ";
    this.message.class = "";
    this.message.icon = "";
    this.message.value = false;
  }
  /**
   * enable the form controls
   */
  enableformControls() {
    this.CreateOrEditForm.get('store').enable();
    this.CreateOrEditForm.get('salesCC').enable();
  }


  /**
  * On Page change 
  * @param pageNumber 
  */
  pageChange(pageNumber: number) {
    if (!isNaN(pageNumber)) {
      this.pageNumber = pageNumber;
      this.getRetailBonusSalesRecords();
    }
  }
  
  /**
  * On Page change 
  * @param pageNumber 
  */

  pageChangeForOrderDetail(pageNumber: number) {
    if (!isNaN(pageNumber)) {
      this.orderDetailPageNumber = pageNumber;
      this.OnclickViewOrders();
    }
  }

  /**
   * populate stores in popup up model
   */
  getStoreData() {
    this.isLoading.retailStores = AnonymousRetailSalesConstants.currentRetailStores;
    this.resetErrorMessage();
    const month: number = (+this.CreateOrEditForm.get('month').value);
    const year: number = +this.CreateOrEditForm.get('year').value;
    if (month && year) {
      this._anonymousRetailOrderService.getStoreDetails(month, year).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        if (res && res.isSuccess) {
          this.retailStores = (res.data && !!res.data.length) ? this.populateStoreInModal(res) : [];
        }
        else {
          this.retailStores = [];
          this.displayModalErrorMsg(res, (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Error_occured_while_fetching_stores) as any).value);
        }
        this.isLoading.retailStores = "";
      }, err => {
        this.retailStores = [];
        this.displayModalErrorMsg('', (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Error_occured_while_fetching_stores) as any).value);
        this.isLoading.retailStores = "";
      }
      )
    }
  }

  displayModalErrorMsg(res, errMsg,id?,action?:string) {
    const message = res && res.validations && !!res.validations.length && res.validations[0].message ? this.handleErrorMsg(res.validations,errMsg,id,action) : errMsg;
    this.handleErrorResponse(message);
  }

  handleErrorMsg(validationMsg, errMsg, id?, action?) {
    let errorMsg = " ";
    if (validationMsg[0] && validationMsg[0].name) {
      if (validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.Already_Exist.toLowerCase() && action == AnonymousRetailSalesConstants.CREATE) {
        errorMsg = (this._translatePipe.get('retail-orders.Shared retail sales is already exists for this store {{storeID}}', { storeID: id ? id :'' }) as any).value;
        return errorMsg;
      }

      if (validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.Not_Exist.toLowerCase() && (action == AnonymousRetailSalesConstants.UPDATE || action == AnonymousRetailSalesConstants.DELETE)) {
        errorMsg = (this._translatePipe.get('retail-orders.Shared retail sale details is not available for this id {{arsid}}',{ arsid: id ? id : '' }) as any).value;
        return errorMsg;
      }

      if (validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.Request_failed.toLowerCase()) {
        errorMsg = (this._translatePipe.get('retail-orders.Error while fetching the store for shared retail sales') as any).value;
        return errorMsg;
      }

      if (validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.Completed.toLowerCase()) {
        errorMsg = (this._translatePipe.get('retail-orders.Stores are not available for this current period {{month}}-{{year}}', {
          month:this.date.getMonth()+1,
          year: this.date.getFullYear()
        }) as any).value;
        return errorMsg;
      }

      if (validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.FAILED.toLowerCase() || validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.Error.toLowerCase()) {
        if (action == AnonymousRetailSalesConstants.Revise) {
          errorMsg = (this._translatePipe.get('retail-orders.Exception Occured while revising the shared retail order sales for id {{arsid}}',{ arsid: id ? id : '' }) as any).value;
          return errorMsg;
        }
        if (action == AnonymousRetailSalesConstants.Approve) {
          errorMsg = (this._translatePipe.get('retail-orders.Error while approving the shared retail sales for id {{arsid}}', { arsid: id ? id : ''  }) as any).value;
          return errorMsg;
        }
        errorMsg = (this._translatePipe.get('retail-orders.' + validationMsg[0].message) as any).value;
        return errorMsg;
      }

    }
    errorMsg = (this._translatePipe.get('retail-orders.' + errMsg) as any).value;
    return errorMsg;
  }

  populateStoreInModal(res) {
    res = { ...res, data: res.data.filter(stores => stores.rowStatusId == RowStatus.Active) };
    let stores = [];
    if (this.userInfo && this.userInfo.hasSystemRole) return [...res.data]
    for (let i = 0; i < res.data.length; i++) {
      let storeHasAccess = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_CREATE + ']'), AccessLevel.Store, +res.data[i].id);
      if (storeHasAccess) {
        stores.push(res.data[i]);
      }
    }
    return [...stores]
  }

  calculateTotalOrderCC(data) {
    const reqObj: RetailSalesModel = {
      categoryName: AnonymousRetailSalesConstants.AnonymousRetailSales,
      categoryIdentifier: AnonymousRetailSalesConstants.RetailSales,
      templateName: "",
      templateExtension: "",
      templatePath: "",
      uploadSourceSystem: AnonymousRetailSalesConstants.CSP,
      destinationSource: AnonymousRetailSalesConstants.Account_Service,
      modifiedBy: this.userInfo.userId,
      fileUploadMetaDataModel: {
        storeId: data.storeID,
        templateIdentifier: data.id
      }
    }
    if (data && data.id && data.storeID) {
      this.overlay = true;
      this._anonymousRetailOrderService.calculateOrderTotalCC(reqObj).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        if (res && res.success) {
        const message: any = (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Calculate_Order_Total_CC_Initiated_Successfully) as any);
        this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
          this.getRetailBonusSalesRecords();
        } else {
          this.displayErrorMsg(res, (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Calculate_Order_Total_CC_Error) as any).value);
        }
      }, err => {
        this.displayErrorMsg('', (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Calculate_Order_Total_CC_Error) as any).value);
      })
    }
  }

  reviseRetailOrder(data) {
    if (data && data.id) {
      this.overlay = true;
      const revisedBy = this.userInfo.userId
      this._anonymousRetailOrderService.reviseRetailOrder(data.id, revisedBy).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        if (res && res.success) {
          const message: any = (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Revise_Intitiated_Successfully) as any);
          this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
          this.getRetailBonusSalesRecords();
        } else {
          this.displayErrorMsg(res, (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Revise_Error) as any).value,data.id,AnonymousRetailSalesConstants.Revise);
        }

      }, err => {
        this.displayErrorMsg('', (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Revise_Error) as any).value);
      })
    }
  }

  trackByStoreID(index: number, store): number {
    return store.id
  }

  trackBySales(index: number, retailSales): number {
    return retailSales.id
  }

  setValuesToForm(data) {
    this.CreateOrEditForm.get('store').setValue(data.storeID.toString())
    this.CreateOrEditForm.get('year').setValue(data.salesYear);
    this.CreateOrEditForm.get('month').setValue(data.salesMonth);
    (data && data.totalSalesCC.toString()) ?
      this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(data.totalSalesCC, '1.3-3')) :
      this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(0, '1.3-3'));
  }

  approve(salesId) {
    this.overlay = true;
    const CreatedBy = this.userInfo.userId
    this._anonymousRetailOrderService.approveRetailOrder(salesId.id, CreatedBy).subscribe(res => {
      if (res && res.success) {
        const message: any = (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Approve_Intitiated_Successfully) as any);
        this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
        this.getRetailBonusSalesRecords();
      } else {
        this.displayErrorMsg(res, (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Approve_Error) as any).value,salesId.id,AnonymousRetailSalesConstants.Approve);
      }
    }, err => {
      this.displayErrorMsg('', (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Approve_Error) as any).value);
    })
  }

  displayErrorMsg(res, errMsg,id?,action?) {
    const message: any = res && !res.success && res.validations && res.validations.length > 0 ? this.handleErrorMsg(res.validations,errMsg,id,action) : errMsg;
    this._commonService.createNotification("", message, NotificationType.ERROR);
    this.overlay = false;
  }

  ngOnDestroy() {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }

  }

  /**
   * View generated orders for anonymous retail sales
   * @param anonymousRetailSalesId 
   */

  OnclickViewOrders(anonymousRetailSalesId?: number,): void {
    /**TODO::Need to uncomment once view order ticket is planned. */ 

    if(this.isEnableViewOrderAndRegenerateOrder){
      this._loader.show();
      if (anonymousRetailSalesId) {
        this.anonymousRetailSalesId = anonymousRetailSalesId;
      }
      this.anonymousRetailOrderDetails = [];
      this.isErrorOccured = false;
      this.noRecordExist = false;
      this.viewOrdersPopup.open();
      const store = this.retailStoresParticipation.filter(country => +country.id == this.storeId);
      this._anonymousRetailOrderService.getOrderdetails(this.anonymousRetailSalesId, this.orderDetailPageSize, this.orderDetailPageNumber).subscribe(response => {
        if (response && response.isSuccess && response.data && response.data.length) {
          for (let i = 0; i < response.data.length; i++) {
            this.anonymousRetailOrderDetail = {
              distributorId: response.data[i].distributorId,
              webOrderID: response.data[i].webOrderID,
              orderCC: response.data[i].orderCC,
              orderTotal: response.data[i].orderTotal,
              orderGenerationStatus: this.anonymousRetailOrderGenerationStatusList.find((element) => response.data[i].orderGenerationStatus === element.id).status,
              orderDate: response.data[i].orderDate ? moment.utc(response.data[i].orderDate).utcOffset(0).format('DD-MMM-YYYY') : '',
              storeName: store[0].name,
              currencyCode: store[0].currencyCode
            }
            this.anonymousRetailOrderDetails.push(this.anonymousRetailOrderDetail);
          }
          this._loader.hide();
          this.orderDetailPageCount = (response.pageDetails) && response.pageDetails.recordsAll ? response.pageDetails.recordsAll : 0;
        }
        else {
          this.anonymousRetailOrderDetails = [];
          this._loader.hide();
          this.noRecordExist = true;
        }
      },
      () => {
        this.anonymousRetailOrderDetails = [];
        this.isErrorOccured = true;
        this._loader.hide();
      });
    }

  }

  /**
   * regenerate the failed orders
   */
  OnclickRegenerateOrders() {
    const store = this.retailStoresParticipation.filter(country => +country.id == this.storeId);
    if (store) {
      let initiateOrder = {
        storeISOCodeThree: store[0].aliasName,
        storeID: store[0].id,
        isWWRTLItemFound: true,
        revisionNumber: '',
        validationModels: null,
        isSuccess: true
      }
      this._anonymousRetailOrderService.regenerateOrders(initiateOrder).subscribe(response => {
        if (response && response.isSuccess) {
          const message: any = (this._translatePipe.get('retail-orders.Regenerated Orders Successfully') as any);
          this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
        }
        else {
          const message = (this._translatePipe.get('retail-orders.Error occured while regenerating the orders') as any).value;
          this._commonService.createNotification("", message, NotificationType.ERROR);
        }
      },
        () => {
          const message = (this._translatePipe.get('customer-service.Something went wrong, Please try again after sometime') as any).value;
          this._commonService.createNotification("", message, NotificationType.ERROR);
        });
    }
  }

  getRetailLogs(retailsRecords) {
    if (retailsRecords && retailsRecords.id) {
      this.overlay = true;
      this._anonymousRetailOrderService.getLogDetails(retailsRecords.id).subscribe(res => {
        const logResponse = { ...res };
        const status = this.populateStatuses(retailsRecords.retailBonusStatus, logResponse);
        this.retailInfoObj = { ...retailsRecords, month: this.monthAndYear.find(month => month.value == +retailsRecords.salesMonth).monthName,logStatus:status };
        this.viewStatusPopup.open();
        this.overlay = false;
      }, err => {
        this.overlay = false;
        const message = (this._translatePipe.get('customer-service.Something went wrong, Please try again after sometime') as any).value;
        this._commonService.createNotification("", message, NotificationType.ERROR);
      }, () => {
        this.overlay = false;
      })
    }
  }

  initialLogStatus() {
    return [
      {
        logStatusID: RetailBonusStatus.PENDING,
        logMessage: (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Month_End_process_is_In_Progress) as any).value,
        logIconClass: AnonymousRetailSalesConstants.Check_icon_progress_class,
        logMsgStatus: AnonymousRetailSalesConstants.Progress,
        logStatus: AnonymousRetailSalesConstants.Completed,
        active: AnonymousRetailSalesConstants.active_Spinner_orange

      },
      {
        logStatusID: RetailBonusStatus.ORDERTOTAL_CALCULATION_INPROGRESS,
        logMessage: (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Order_Total_and_CC_Calculation_is_In_Progress) as any).value,
        logIconClass: AnonymousRetailSalesConstants.Pending_icon_class,
        logMsgStatus: AnonymousRetailSalesConstants.Progress,
        logStatus: AnonymousRetailSalesConstants.Pending,
        active: ''

      },
      {
        logStatusID: RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS,
        logMessage: (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.WWRTL_Product_File_Upload_In_Progress) as any).value,
        logIconClass: AnonymousRetailSalesConstants.Pending_icon_class,
        logMsgStatus: AnonymousRetailSalesConstants.Progress,
        logStatus: AnonymousRetailSalesConstants.Pending,
        active: ''

      },
      {
        logStatusID: RetailBonusStatus.ORDER_GENERATION_INPROGRESS,
        logMessage: (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Product_revision_set_with_WWRTL_Item_uploaded_to_Titan) as any).value,
        logIconClass: AnonymousRetailSalesConstants.Pending_icon_class,
        logMsgStatus:AnonymousRetailSalesConstants.Revision,
        logStatus: AnonymousRetailSalesConstants.Pending,
        active: ""
    },
      {
        logStatusID: RetailBonusStatus.ORDER_GENERATION_INPROGRESS,
        logMessage: (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Order_Creation_in_Progress) as any).value,
        logIconClass: AnonymousRetailSalesConstants.Pending_icon_class,
        logMsgStatus: AnonymousRetailSalesConstants.Progress,
        logStatus: AnonymousRetailSalesConstants.Pending,
        active: ''

      },
      {
        logStatusID: RetailBonusStatus.PENDING,
        logMessage: (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Month_End_process_is_Completed) as any).value,
        logIconClass: AnonymousRetailSalesConstants.Pending_icon_class,
        logMsgStatus: AnonymousRetailSalesConstants.Completed,
        logStatus: AnonymousRetailSalesConstants.Pending,
        active: ''

      }
    ]
  }


  populateStatuses(recordsStatus, logResponse) {
    let logStatuses = [...this.initialLogStatus()];
    recordsStatus = +recordsStatus

    switch (recordsStatus) {
      case RetailBonusStatus.PENDING:
        logStatuses = [...this.initialLogStatus()];
        if (logResponse && logResponse.displayOrderCCCalculationFailLog) {
          logStatuses = [...this.orderCalculationFailedLogs()];
        }
        break;

      case RetailBonusStatus.QUALIFIED_SUBSCRIBER_NOT_AVAILABLE:
        logStatuses = [...this.qualifiedSubscribersLogs()];
        break;

      case RetailBonusStatus.SUBSCRIBER_NOT_AVAILABLE:
        logStatuses = [...this.subscribersLogs()];
        break;


      case RetailBonusStatus.ORDERTOTAL_CALCULATION_INPROGRESS:
        logStatuses = [...this.orderCalculationProgressLogs()];
        break;

      case RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS:
        logStatuses = [...this.orderCalculationSuccessLogs()];
        if (logResponse && logResponse.displayReviseFailureLog) {
          logStatuses = [...this.reviseFailedLog()];
        }
        break;

      case RetailBonusStatus.REVISE_INPROGRESS:
        logStatuses = [...this.reviseProgressLog()];
        break;

      case RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS:
        logStatuses = [...this.fileuploadProgress()];
        break;

      case RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS:
        logStatuses = [...this.fileuploadSuccess()];
        break;

      case RetailBonusStatus.PRODUCT_FILE_UPLOAD_FAILED:
        logStatuses = [...this.fileuploadFailed()];
        break;

      case RetailBonusStatus.ORDER_GENERATION_INPROGRESS:
        if (logResponse && logResponse.displayWWRTLItemFoundLog) {
          logStatuses = [...this.orderGenerationInProgress()];
        }
        else {
          logStatuses = [...this.fileuploadSuccess()];
        }
        break;

      case RetailBonusStatus.ORDER_GENERATION_SUCCESS:
        if (logResponse && logResponse.displayWWRTLItemFoundLog) {
          logStatuses = [...this.orderGenerationSuccess()]
        }
        else {
          logStatuses = [...this.fileuploadSuccess()];
        }
        break;

      case RetailBonusStatus.ORDER_GENERATION_FAILED:
        logStatuses = [...this.orderGenerationFailed()];
        break;

      default:
        logStatuses = [...this.initialLogStatus()];
        break;
    }
    return [...logStatuses];

  }

  qualifiedSubscribersLogs() {
    return [
      {
        logStatusID: RetailBonusStatus.PENDING,
        logMessage: (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Month_End_process_is_In_Progress) as any).value,
        logIconClass: AnonymousRetailSalesConstants.Check_icon_progress_class,
        logMsgStatus: AnonymousRetailSalesConstants.Progress,
        logStatus: AnonymousRetailSalesConstants.Completed,
        active: ''

      },
      {
        logStatusID: RetailBonusStatus.QUALIFIED_SUBSCRIBER_NOT_AVAILABLE,
        logMessage: (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Qualified_subscribers_are_not_available_in_this_store) as any).value,
        logIconClass: AnonymousRetailSalesConstants.Error_icon_class,
        logMsgStatus: AnonymousRetailSalesConstants.Not_Available,
        logStatus: AnonymousRetailSalesConstants.FAILED,
        active: AnonymousRetailSalesConstants.active_Spinner_Red
      }
    ]
  }

  subscribersLogs() {
    return [
      {
        logStatusID: RetailBonusStatus.PENDING,
        logMessage: (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Month_End_process_is_In_Progress) as any).value,
        logIconClass: AnonymousRetailSalesConstants.Check_icon_progress_class,
        logMsgStatus: AnonymousRetailSalesConstants.Progress,
        logStatus: AnonymousRetailSalesConstants.Completed,
        active: ''

      },
      {
        logStatusID: RetailBonusStatus.SUBSCRIBER_NOT_AVAILABLE,
        logMessage: (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Subscribers_are_not_available_in_this_store) as any).value,
        logIconClass: AnonymousRetailSalesConstants.Error_icon_class,
        logMsgStatus: AnonymousRetailSalesConstants.Not_Available,
        logStatus: AnonymousRetailSalesConstants.FAILED,
        active: AnonymousRetailSalesConstants.active_Spinner_Red

      }
    ]
  }

  orderCalculationProgressLogs() {
    const initialLogs = [...this.initialLogStatus()];

    const MonthEndProcess = initialLogs.find(x => (x.logStatusID == RetailBonusStatus.PENDING && x.logMsgStatus == AnonymousRetailSalesConstants.Progress));
    MonthEndProcess.active = '';

    const getOrderCCProgress = initialLogs.find(x => (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress));
    getOrderCCProgress.logIconClass = AnonymousRetailSalesConstants.Check_icon_progress_class;
    getOrderCCProgress.logStatus = AnonymousRetailSalesConstants.Completed;
    getOrderCCProgress.active = AnonymousRetailSalesConstants.active_Spinner_orange;
    return [...initialLogs];
  }

  orderCalculationSuccessLogs() {
    const orderCalculationProgressLogs = [...this.orderCalculationProgressLogs()];

    let orderCalculationInProgressIndex = orderCalculationProgressLogs.findIndex(x => x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress);
    const getOrderCCCompletedLog = this.populateLogMsgDetail(RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS, AnonymousRetailSalesConstants.Order_Total_and_CC_Calculation_is_Completed,
      AnonymousRetailSalesConstants.Check_icon_class, AnonymousRetailSalesConstants.Completed, AnonymousRetailSalesConstants.Completed, AnonymousRetailSalesConstants.active_Spinner_Green);
    orderCalculationProgressLogs.splice(orderCalculationInProgressIndex, 1, getOrderCCCompletedLog);

    return [...orderCalculationProgressLogs];
  }

  orderCalculationFailedLogs() {
    const initialLogs = [...this.initialLogStatus()];

    const MonthEndProcess = initialLogs.find(x => (x.logStatusID == RetailBonusStatus.PENDING && x.logMsgStatus == AnonymousRetailSalesConstants.Progress));
    MonthEndProcess.active = '';

    const getIndexOfMonthEndProcess = initialLogs.findIndex(x => (x.logStatusID == RetailBonusStatus.PENDING && x.logMsgStatus == AnonymousRetailSalesConstants.Progress));
    const iterateOrderCCFailedLog = this.populateLogMsgDetail(RetailBonusStatus.ORDERTOTAL_CALCULATION_INPROGRESS, AnonymousRetailSalesConstants.Order_Total_and_CC_Calculation_is_Failed,
      AnonymousRetailSalesConstants.Error_icon_class, AnonymousRetailSalesConstants.FAILED, AnonymousRetailSalesConstants.FAILED, AnonymousRetailSalesConstants.active_Spinner_Red);
    initialLogs.splice(getIndexOfMonthEndProcess + 1, 1, iterateOrderCCFailedLog);
    return [...initialLogs];

  }

  reviseProgressLog() {
    const reviseLogs = [...this.orderCalculationSuccessLogs()];

    const orderCalculationSuccess = reviseLogs.find(x => (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed));
    orderCalculationSuccess.active = '';

    const getIndexOfOrderCCSuccess = reviseLogs.findIndex(x => (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed));
    const iterateReviseProgressLog = this.populateLogMsgDetail(RetailBonusStatus.REVISE_INPROGRESS, AnonymousRetailSalesConstants.Revise_Action_is_In_Progress,
      AnonymousRetailSalesConstants.Check_icon_progress_class, AnonymousRetailSalesConstants.Progress, AnonymousRetailSalesConstants.Completed, AnonymousRetailSalesConstants.active_Spinner_orange);
    reviseLogs.splice(getIndexOfOrderCCSuccess + 1, 0, iterateReviseProgressLog);

    return [...reviseLogs];

  }


  reviseFailedLog() {
    const reviseLogs = [...this.orderCalculationSuccessLogs()];

    const orderCalculationSuccess = reviseLogs.find(x => (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed));
    orderCalculationSuccess.active = '';

    const getIndexOfOrderCCSuccess = reviseLogs.findIndex(x => (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed));
    const iterateReviseProgressLog = this.populateLogMsgDetail(RetailBonusStatus.REVISE_INPROGRESS, AnonymousRetailSalesConstants.Revise_Action_is_Failed,
      AnonymousRetailSalesConstants.Error_icon_class, AnonymousRetailSalesConstants.FAILED, AnonymousRetailSalesConstants.FAILED, AnonymousRetailSalesConstants.active_Spinner_Red);
    reviseLogs.splice(getIndexOfOrderCCSuccess + 1, 0, iterateReviseProgressLog);

    return [...reviseLogs];

  }

  fileuploadProgress() {
    const fileUploadProgressLogs = [...this.orderCalculationSuccessLogs()];

    const orderCalculationSuccess = fileUploadProgressLogs.find(x => (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed));
    orderCalculationSuccess.active = '';

    const fileUploadProgress = fileUploadProgressLogs.find(x => (x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress));
    fileUploadProgress.logStatus = AnonymousRetailSalesConstants.Completed;
    fileUploadProgress.active = AnonymousRetailSalesConstants.active_Spinner_orange;
    fileUploadProgress.logIconClass = AnonymousRetailSalesConstants.Check_icon_progress_class;

    return [...fileUploadProgressLogs];
  }

  fileuploadSuccess() {
    const fileUploadSuccessLogs = [...this.fileuploadProgress()];

    const fileUploadProgressIndex = fileUploadSuccessLogs.findIndex(x => (x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress));
    const iteratefileUploadSuccessLog = this.populateLogMsgDetail(RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS, AnonymousRetailSalesConstants.WWRTL_Product_File_Upload_Completed,
      AnonymousRetailSalesConstants.Check_icon_class, AnonymousRetailSalesConstants.Completed, AnonymousRetailSalesConstants.Completed,  AnonymousRetailSalesConstants.active_Spinner_Green);
      fileUploadSuccessLogs.splice(fileUploadProgressIndex , 1, iteratefileUploadSuccessLog);

    return [...fileUploadSuccessLogs]
  }

  fileuploadFailed() {
    const fileUploadFailedLogs = [...this.orderCalculationSuccessLogs()];

    const orderCalculationSuccess = fileUploadFailedLogs.find(x => (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed));
    orderCalculationSuccess.active = '';

    const fileUploadProgress = fileUploadFailedLogs.find(x => (x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress));
    fileUploadProgress.logStatus = AnonymousRetailSalesConstants.FAILED;
    fileUploadProgress.active = AnonymousRetailSalesConstants.active_Spinner_Red;
    fileUploadProgress.logIconClass = AnonymousRetailSalesConstants.Error_icon_class;
    fileUploadProgress.logMessage = (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.WWRTL_Product_File_Upload_Failed) as any).value;
    fileUploadProgress.logMsgStatus = AnonymousRetailSalesConstants.FAILED;

    return [...fileUploadFailedLogs];
  }

  orderGenerationInProgress() {
    const orderGenerationInProgressLogs = [...this.fileuploadSuccess()];
    let fileUploadInProgress = orderGenerationInProgressLogs.find(x => x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed);
    fileUploadInProgress.active = '';

    const revisionSet = orderGenerationInProgressLogs.find(x => x.logStatusID == RetailBonusStatus.ORDER_GENERATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Revision);
    revisionSet.active = '';
    revisionSet.logStatus = AnonymousRetailSalesConstants.Completed;
    revisionSet.logIconClass = AnonymousRetailSalesConstants.Check_icon_class;

    const orderGenerationInProgress = orderGenerationInProgressLogs.find(x => x.logStatusID == RetailBonusStatus.ORDER_GENERATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress);
    orderGenerationInProgress.logStatus = AnonymousRetailSalesConstants.Completed;
    orderGenerationInProgress.active = AnonymousRetailSalesConstants.active_Spinner_orange;
    orderGenerationInProgress.logIconClass = AnonymousRetailSalesConstants.Check_icon_progress_class;


    return [...orderGenerationInProgressLogs];
  }

  orderGenerationSuccess() {
    const orderGenerationLogs = [...this.orderGenerationInProgress()];
    const monthEndInProgress = orderGenerationLogs.findIndex(x => (x.logStatusID == RetailBonusStatus.PENDING && x.logMsgStatus == AnonymousRetailSalesConstants.Progress));
    orderGenerationLogs.splice(monthEndInProgress,1);

    const orderGenerationSuccess = orderGenerationLogs.find(x => x.logStatusID == RetailBonusStatus.ORDER_GENERATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress);
    orderGenerationSuccess.logIconClass = AnonymousRetailSalesConstants.Check_icon_class;
    orderGenerationSuccess.logStatus = AnonymousRetailSalesConstants.Completed;
    orderGenerationSuccess.logMsgStatus = AnonymousRetailSalesConstants.Completed;
    orderGenerationSuccess.logMessage = AnonymousRetailSalesConstants.Order_Creation_Completed;
    orderGenerationSuccess.active = '';

    const monthEndSuccess = orderGenerationLogs.find(x => x.logStatusID == RetailBonusStatus.PENDING && x.logMsgStatus == AnonymousRetailSalesConstants.Completed);
    monthEndSuccess.logIconClass = AnonymousRetailSalesConstants.Check_icon_class;
    monthEndSuccess.logStatus = AnonymousRetailSalesConstants.Completed;
    monthEndSuccess.active = AnonymousRetailSalesConstants.active_Spinner_Green;

    return [...orderGenerationLogs]
  }

  orderGenerationFailed() {
    const orderGenerationFailed = [...this.fileuploadSuccess()];

    const orderFileUploadSuccess = orderGenerationFailed.find(x => x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed);
    orderFileUploadSuccess.active = '';

    const orderFileUploadSuccessIndex = orderGenerationFailed.findIndex(x => x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed);
    orderGenerationFailed.splice(orderFileUploadSuccessIndex + 1, 1);

    const orderGenerationInProgress = orderGenerationFailed.find(x => x.logStatusID == RetailBonusStatus.ORDER_GENERATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress);
    orderGenerationInProgress.logStatus = AnonymousRetailSalesConstants.FAILED;
    orderGenerationInProgress.active = AnonymousRetailSalesConstants.active_Spinner_Red;
    orderGenerationInProgress.logIconClass = AnonymousRetailSalesConstants.Error_icon_class;
    orderGenerationInProgress.logMessage = (this._translatePipe.get('retail-orders.'+AnonymousRetailSalesConstants.Order_Creation_Failed) as any).value;
    orderGenerationInProgress.logMsgStatus = AnonymousRetailSalesConstants.FAILED;

    return [...orderGenerationFailed];

  }


  populateLogMsgDetail(status: number, msg: string, iconClass: string, msgStatus: string, logStatus: string, active: string) {
    return {
      logStatusID: status,
      logMessage: (this._translatePipe.get('retail-orders.'+msg) as any).value,
      logIconClass: iconClass,
      logMsgStatus: msgStatus,
      logStatus: logStatus,
      active: active
    }
  }

 statusClose(){
    this.viewStatusPopup.close();
  }

  }

  






// WEBPACK FOOTER //
// ./src/app/customerservice/components/orders/anonymous-retail-order.component.ts